export const NO_RECORD_MESSAGE = 'No records were found.';
export const BUTTON_LABEL = {
    filter: 'Filter',
    submit: 'Submit',
    manageCategories: 'Manage categories',
    saveCustomSearch: 'Save as Custom Search',
    cancel: 'Cancel',
    confirm: 'Confirm',
    create: 'Create',
    share: 'Share',
    download: 'Download',
    save: 'Save',
};
export const INPUT_LABEL = {
    search: 'Search',
};
export const COMMON_ERROR_MESSAGES = {
    DATE_CHOSEN_CAN_NOT_BE: `Reader activation and expiration dates cannot exceed the timeframe of
        the badge activation and expiration dates.`,
};
export const SELECT_LABEL = {
    DEFAULT_PLACEHOLDER: 'Select',
    DEFAULT_SEARCH_PLACEHOLDER: 'Search',
    DEFAULT_TIMEPICKER_PLACEHOLDER: '--:-- AM',
};
export const GLOBAL_NAVIGATION = {
    TABS: {
        INTERNAL: {
            TITLE: 'Internal',
            SUB_TABS: {
                ASSOCIATE_RESOURCES: {
                    TITLE: 'Associate Resources',
                },
                INTERNAL_INTEGRATIONS: {
                    TITLE: 'Internal Integrations',
                },
            },
        },
    },
};
export const COMMON_FILTER_LABLE = {
    DATE_INTERVAL: {
        DATE_TYPE: 'Date Type',
        DATES: 'Dates',
        DATE_FROM: 'Date from',
        DATE_TO: 'Date to',
    },
};
export const PERMISSION_COMPONENT = {
    CREATE_CUSTOM_ROLE: 'Create Custom Role',
    NO_DATA_FOUND: 'No Data Found',
    NO_RECORD_MESSAGE: 'Please select Company and Building(s) to continue.',
    APPLY_FOR_ALL: 'Apply these selections to all remaining selected buildings',
};
export const NO_PRIVILEGE_LABLE = {
    HEADING: 'NOT AUTHORIZED',
    TYPE: {
        REMOTE_HANDS: 'You are not authorized to request REMOTE_HANDS.',
        SHIPMENT_NOTICE: 'You are not authorized to request SHIPMENT_NOTICE.',
        CASE: 'You are not authorized to request CASE.',
        DNS_CHANGE: 'You are not authorized to request DNS_CHANGE.',
        EQUIPMENT_REMOVAL: 'You are not authorized to request EQUIPMENT_REMOVAL.',
        FIREWALL_RULE_CHANGE: 'You are not authorized to request FIREWALL_RULE_CHANGE.',
    },
};
export const NOTIFICATION_DETAIL = {
    EMAIL_DISPATCHED: 'Email(s) have been dispatched.',
    COULD_NOT_COMPLETE_REQUEST: 'Could not complete your request',
};
